import React from "react";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import FormGenerator from "components/customs/form-generator/input";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import { NewsCustomFormStyle } from "constants/style";
import { TWENTIETH_CONGRESS } from "utility/constants";
import { genericGet } from "services/services.general";
import { VIEW_ACTION } from "constants/actions";
import styled from "styled-components";
import { StyledFontAwesomeIcon } from "assets/js/Styles";

const CustomFormContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

const CustomForm = styled.div`
  display: grid;
  gap: 1rem;
  grid-auto-flow: column;
  grid-template-columns: 43% 25% 25% 3%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  align-items: center;
`;

const CustomFormAddRowSection = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const AddRowButton = styled(Button)`
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.colors.blue50};
  border-radius: 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.blue50};
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 15px;
  margin-top: 2rem;
`;

const StyledFormField = styled(FormGenerator)`
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;

  &:focus {
    box-shadow: none;
  }
`;

const CustomFormDeleteRowIcon = styled.div``;

const defaultSelectedCongressmen = {
  name: null,
  area: "",
  contact: "63",
};

const CustomCongressmanSelection = ({ action, setRecipients, recipients }) => {
  const [selectedCongs, setSelectedCongs] = React.useState([
    defaultSelectedCongressmen,
  ]);

  const handleSearch = _.debounce((inputValue, callback) => {
    genericGet({
      url: "/congressman",
      params: {
        search: inputValue,
        congress: TWENTIETH_CONGRESS,
      },
      callback: (data) => {
        if (data?.length) {
          const options = data
            ?.filter((d) => !recipients.include.includes(d.id))
            ?.map((item) => ({
              ...item,
              label: item?.name,
              value: item?.id,
            }));

          callback(options);
        } else {
          callback([]);
        }
      },
    });
  }, 1000);

  const handleSearchOnChange = (option, idx) => {
    const newSelectedCongs = [...selectedCongs];

    newSelectedCongs[idx] = {
      name: {
        label: option.name,
        value: option.id,
      },
      contact: option.contact,
      area: option?.region?.acronym || "",
    };

    setSelectedCongs(newSelectedCongs);

    setRecipients({
      ...recipients,
      include: [...recipients.include, option.id],
    });
  };

  const handleDeleteRow = (index) => {
    const newSelectedCongs = [...selectedCongs];
    newSelectedCongs.splice(index, 1);
    setSelectedCongs(newSelectedCongs);
  };

  const handleAddRow = () => {
    const newSelectedCongs = [...selectedCongs];
    newSelectedCongs.push(defaultSelectedCongressmen);
    setSelectedCongs(newSelectedCongs);
  };

  return (
    <CustomFormContainer>
      {selectedCongs.map((cong, idx) => (
        <CustomForm>
          <AsyncSelect
            placeholder="Name"
            styles={NewsCustomFormStyle}
            value={cong.name}
            onChange={(option) => {
              handleSearchOnChange(option, idx);
            }}
            loadOptions={handleSearch}
            isDisabled={action === VIEW_ACTION}
          />

          <StyledFormField
            type="text"
            placeholder="Area"
            value={cong.area}
            isDisabled
            onChange={(event) => {
              const {
                target: { value },
              } = event;

              const newSelectedCongs = [...selectedCongs];

              newSelectedCongs[idx] = {
                ...newSelectedCongs[idx],
                area: value,
              };

              setSelectedCongs(newSelectedCongs);
            }}
          />

          <StyledFormField
            type="mobile"
            placeholder="Contact Number"
            value={cong.contact}
            isDisabled
            onChange={(value) => {
              const newSelectedCongs = [...selectedCongs];

              newSelectedCongs[idx] = {
                ...newSelectedCongs[idx],
                contact: value,
              };

              setSelectedCongs(newSelectedCongs);
            }}
          />

          {idx !== 0 && (
            <CustomFormDeleteRowIcon
              aria-hidden
              onClick={() => handleDeleteRow(idx)}
            >
              <StyledFontAwesomeIcon
                size="xl"
                icon={faCircleXmark}
              />
            </CustomFormDeleteRowIcon>
          )}
        </CustomForm>
      ))}

      <CustomFormAddRowSection>
        <AddRowButton onClick={handleAddRow}>{"Add Row"}</AddRowButton>
      </CustomFormAddRowSection>
    </CustomFormContainer>
  );
};

export default CustomCongressmanSelection;
